import LandingPage from "../LandingPage.jsx";

export default function LandingFr() {
  return <LandingPage forcedLang="fr" />;
}